module.exports = __webpack_public_path__ + "img/sj.cb80dad2.png";